import { Dialog } from '@portals/core/src/components/Dialog/Dialog';
import { RedirectBox } from '@portals/core/src/components/RedirectBox/RedirectBox';
import { useSPKCookie } from '@portals/forms/src/hooks/useSPKCookie/useSPKCookie';
import { getFixedT } from 'i18next';
import React from 'react';

const t = getFixedT(null, 'core-immobilien', 'watchlist.cockpit.redirectBox');

type Props = {
  onClose: () => void;
  onRedirect: () => void;
};

export const CockpitRedirectDialog: React.FC<Props> = ({ onClose, onRedirect }) => {
  const { bankName } = useSPKCookie();

  return (
    <Dialog open onClose={onClose}>
      <RedirectBox headline={t('title')} bankName={bankName} redirect={onRedirect} />
    </Dialog>
  );
};

CockpitRedirectDialog.displayName = 'CockpitRedirectDialog';
